import BaseCefCommercialService from "./base.service";
import { CefVersion } from "./constants";
import { activityLogArea } from "../user-tracking-helper";

export type Invoice = {
    documentType: string;
    documentId: string;
    invoiceDate: Date;
    dueDate: Date;
}

class InvoiceService extends BaseCefCommercialService {
    constructor(abortController: AbortController | null = null, skipValidation = false) {
        super(activityLogArea.invoices, abortController);
        this.setBaseUrl(`CEFCommInvoicesAPI/${CefVersion}`);

        if (skipValidation) {
            return;
        }

        this.validateCustomerNumber();
    }

    getInvoices(startDate: string | Date, endDate: string | Date) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const startParam = this.getDateString(start);
        const endParam = this.getDateString(end)

        const request = {
            customerNumber: this.customerNumber,
            dateRange: {
                start: startParam,
                end: endParam
            }
        };

        this.userTracking.read(request);

        const path = `customers/${this.customerNumber}/invoices?from=${startParam}&to=${endParam}`;

        return this.createPromiseRequest(path).get<Invoice[]>();
    }

    downloadInvoice(documentId: string) {
        this.userTracking.download({ documentId: documentId });

        const path = `customers/${this.customerNumber}/invoices/${documentId}`;
        return this.createPromiseRequest(path)
            .withResponseType("arraybuffer")
            .get<any>();
    }
}

export default InvoiceService;
